import { render, staticRenderFns } from "./SpeechBubble.vue?vue&type=template&id=3a41b16e"
import script from "./SpeechBubble.vue?vue&type=script&lang=js"
export * from "./SpeechBubble.vue?vue&type=script&lang=js"
import style0 from "./SpeechBubble.vue?vue&type=style&index=0&id=3a41b16e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports